// Custom markdown components configuration
// This ensures all links in markdown content open in a new tab with proper security attributes

export const markdownComponents = {
  a: ({ node, ...props }) => (
    <a {...props} target="_blank" rel="noopener noreferrer" />
  ),
};
